<template>
    <div>
      <MainPage type="DECLARATION_COTISATION_OLD"/>
    </div>
</template>

<script>


import MainPage from "@/views/Impression/DeclarationCotisation/Components/MainPage.vue";

export default {
    components: {MainPage}
}
</script>

<style scoped>

</style>